import { Loader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { EditClientForm } from '~/features/EditClientForm';
import { EditClientHeader } from '~/features/EditClientHeader';
import styles from './EditClientScreenContent.module.scss';

type Props = {
  clientId: number;
};

export const EditClientScreenContent: React.FC<Props> = ({ clientId }) => {
  return (
    <>
      <Suspense fallback={<Loader />}>
        <EditClientHeader clientId={clientId} />
      </Suspense>
      <div className={styles.content}>
        <Suspense fallback={<Loader />}>
          <EditClientForm clientId={clientId} />
        </Suspense>
      </div>
    </>
  );
};
